import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6f72fcba")

_pushScopeId("data-v-6f72fcba")
const _hoisted_1 = { class: "overflow-hidden" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("制作音频")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_slot_form = _resolveComponent("slot-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_step = _resolveComponent("el-step")
  const _component_el_steps = _resolveComponent("el-steps")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_page_header, {
      onBack: _ctx.goBack,
      content: "编辑槽位"
    }, null, 8, ["onBack"]),
    _createVNode(_component_el_divider),
    _createVNode(_component_el_steps, {
      class: "slots",
      direction: "vertical",
      active: -1,
      "align-center": ""
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slots, (slot) => {
          return (_openBlock(), _createBlock(_component_el_step, {
            key: slot.id,
            title: _ctx.getTitle(slot)
          }, _createSlots({
            description: _withId(() => [
              (slot.id !== -1)
                ? (_openBlock(), _createBlock(_component_slot_form, {
                    key: 0,
                    showDelete: _ctx.slots.length > 2,
                    onDeleted: _ctx.handleDeleted,
                    onAddSlot: _ctx.addSlotAt,
                    onSuccess: _ctx.slotUpdated,
                    sortNumber: _ctx.slots.indexOf(slot),
                    templateId: _ctx.templateId,
                    slotData: slot
                  }, null, 8, ["showDelete", "onDeleted", "onAddSlot", "onSuccess", "sortNumber", "templateId", "slotData"]))
                : _createCommentVNode("", true),
              (slot.id === -1 && _ctx.slots.find(i => i.id > 0))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "success",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({name: 'DemoCreator'})))
                  }, {
                    default: _withId(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, [
            (slot.id !== -1)
              ? {
                  name: "icon",
                  fn: _withId(() => [
                    _createVNode("strong", null, _toDisplayString(_ctx.slots.indexOf(slot) + 1), 1)
                  ])
                }
              : undefined
          ]), 1032, ["title"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
})